// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-info-key {
    margin-top: 10%;
    /* margin-bottom: 11.1%; */
    background-color: #fff;
    padding-top: 50px;
    border-radius: 1em;
    /* padding: 50px; */
    box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;
    height: 250px;
    margin-left: 2px;
    width: 350px !important;
}
.container-info-data {
    box-shadow: rgba(9, 30, 66, 0.25) 0px 1px 1px, rgba(9, 30, 66, 0.13) 0px 0px 1px 1px;
}`, "",{"version":3,"sources":["webpack://./src/components/Report/SummaryReport/SummaryReport.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,0BAA0B;IAC1B,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,qFAAqF;IACrF,aAAa;IACb,gBAAgB;IAChB,uBAAuB;AAC3B;AACA;IACI,oFAAoF;AACxF","sourcesContent":[".container-info-key {\n    margin-top: 10%;\n    /* margin-bottom: 11.1%; */\n    background-color: #fff;\n    padding-top: 50px;\n    border-radius: 1em;\n    /* padding: 50px; */\n    box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;\n    height: 250px;\n    margin-left: 2px;\n    width: 350px !important;\n}\n.container-info-data {\n    box-shadow: rgba(9, 30, 66, 0.25) 0px 1px 1px, rgba(9, 30, 66, 0.13) 0px 0px 1px 1px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
